import React, { useEffect, useState } from 'react';
import { query, collection, where, getDocs, updateDoc, doc } from 'firebase/firestore';
import { db } from '../../../../firebase';
import { Job, JobStatus } from '../../../../app/pages/job-summary/Interfaces';
import JobEditModal from '../../job-summary/JobEditModal';
import JobWorkspaceModal from '../../job-summary/JobWorkspaceModal';
import JobStatusService from '../../../utils/jobStatusService';


interface SelectedClientJobsProps {
  customerId: string | null;
}

const getBorderColor= (status: string) => {
    switch (status) {
      case 'Open':
        return 'red';
      case 'Closed':
        return '#50CD89';
      case 'Pending':
        return 'orange';
      default:
        return ''; // Default border color
    }
  }

  const handleUpdateJobStatus = async (jobId: string, newStatus: JobStatus) => {
    try {
      const result = await JobStatusService.updateJobStatus(
        jobId, 
        newStatus, 
        'user', 
        'Manual status change from client focus'
      );
      
      if (result.success) {
        console.log("Job status updated successfully:", jobId);
      } else {
        console.error("Failed to update job status:", result.error);
      }
    } catch (error) {
      console.error("Error updating job status:", error);
    }
  };

const SelectedClientJobs: React.FC<SelectedClientJobsProps> = ({ customerId }) => {
  const [jobs, setJobs] = useState<Job[]>([]);
  const [selectedJob, setSelectedJob] = useState<Job | null>(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isTaskModalOpen, setIsTaskModalOpen] = useState(false);

  // Function to open the task modal and set the selected job
  const handleJobClick = (job: Job) => {
    setSelectedJob(job);
    setIsTaskModalOpen(true);
  };
  // Function to close the task modal and clear the selected job
  const handleTaskModalClose = () => {
    setIsTaskModalOpen(false);
  };

// Function to open the edit modal and set the selected job
const handleOpenEditModal = (job: Job) => {
  setSelectedJob(job);
  setIsEditModalOpen(true);
};

// Function to close the edit modal and clear the selected job
const handleCloseEditModal = () => {
  setSelectedJob(null);
  setIsEditModalOpen(false);
};

  useEffect(() => {
    const fetchJobs = async () => {
      if (customerId) {
        const jobsQuery = query(collection(db, 'jobs'), where('customerId', 'array-contains', customerId));
        const querySnapshot = await getDocs(jobsQuery);
        console.log('Fetched jobs:', querySnapshot.docs.map(doc => doc.data())); // Log the fetched jobs
        setJobs(querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }) as Job));
      }
    };
  
    fetchJobs();
  }, [customerId]);

  return (
<div className="container mt-3">
{
  selectedJob && 
  <JobEditModal 
    key={selectedJob.id} 
    show={isEditModalOpen} 
    job={selectedJob} 
    onHide={handleCloseEditModal} 
  />
}
{
  selectedJob && 
  <JobWorkspaceModal 
    key={selectedJob.id} 
    show={isTaskModalOpen} 
    job={selectedJob} 
    onHide={handleTaskModalClose} 
  />
}
    <div className="container mt-3">
      <div className="card">
        <div className="card-header">
          <h2>Jobs</h2>
          customer id: {customerId}
        </div>
        <div className="card-body">
          <table className="table table-hover">
            <thead>
              <tr>
              <th className=" fs-6"><b>Creation Date</b></th>
                <th className=" fs-6"><b>Job Label</b></th>
                <th className=" fs-6"><b>Status</b></th>
                <th className=" fs-6"><b>Actions</b></th>
              </tr>
            </thead>
            <tbody>
            {jobs.map((job, index) => (
  <tr key={index} onClick={() => handleJobClick(job)}>
    <td className="">{job.creationDate}</td>
    <td className="">{job.jobLabel}</td>
    <td className="">
    <select
        className="form-select"
        style={{
          width: '70%',
          fontSize: '0.8rem',
          borderColor: JobStatusService.getStatusColor(job.status) // Use service for colors
        }}
        value={job.status}
        onChange={(e) => {
          // Update the status in the local state
          const updatedJobs = [...jobs];
          updatedJobs[index].status = e.target.value as JobStatus;
          setJobs(updatedJobs);
        }}
        onBlur={() => handleUpdateJobStatus(job.id, jobs[index].status)} // Use the updated job status
        onClick={(e) => e.stopPropagation()} // Stop propagation of the click event
      >
        <option value="Pending">Pending Start</option>
        <option value="Open">Ready to Start</option>
        <option value="Awaiting Client Response">Awaiting Response</option>
        <option value="Overdue">Overdue</option>
        <option value="Closed">Completed</option>
        <option value="Cancelled">Cancelled</option>
        <option value="Archived">Archived</option>
      </select>
    </td>
    <td className="">
    <button onClick={(e) => {e.stopPropagation(); handleOpenEditModal(job);}} className="btn btn-link p-0 me-2">
  <i className="bi bi-pencil-square fs-3"></i>
</button>
      <button className="btn btn-link p-0" onClick={(e) => e.stopPropagation()}>
        <i className="bi bi-trash fs-3"></i>
      </button>
    </td>
  </tr>
))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
    </div>
  );
};

export default SelectedClientJobs;